import { render, staticRenderFns } from "./NoteDetailView.html?vue&type=template&id=07f356c2&"
import script from "./NoteDetailView.component.js?vue&type=script&lang=js&"
export * from "./NoteDetailView.component.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports